import { ApiReleaseShipmentRequest } from 'src/app/core/models';

export const releaseShipment = (): ApiReleaseShipmentRequest => {
  return {
    patientId: 1000,
    paymentProcessed: 'Y',
    referenceNumber: 1234567890,
    targetedShipDate: '2021-01-01',
  };
};

export const setReleaseShipment = () => {};
